import React, { ReactElement } from 'react'
import { SvgIcon, SvgIconProps } from '@material-ui/core'

export const CrmIcon: (props: SvgIconProps) => ReactElement = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props} viewBox='0 0 906 894'>
        <g transform='translate(0.000000,894.000000) scale(0.100000,-0.100000)' stroke='none'>
            <path
                d='M1565 8679 c-22 -6 -67 -14 -100 -19 -72 -11 -136 -27 -190 -47 -22
-9 -58 -22 -80 -30 -101 -38 -304 -147 -350 -190 -11 -10 -56 -47 -99 -83 -85
-70 -85 -70 -173 -175 -32 -38 -66 -79 -76 -90 -44 -48 -151 -247 -192 -355
-9 -25 -23 -60 -31 -78 -8 -18 -14 -40 -14 -49 0 -9 -6 -39 -14 -67 -48 -170
-46 -37 -46 -3051 0 -3014 -2 -2881 46 -3051 8 -28 14 -58 14 -67 0 -9 6 -31
14 -49 8 -18 22 -53 31 -78 41 -108 148 -307 192 -355 10 -11 44 -52 76 -90
88 -105 88 -105 173 -175 43 -36 88 -73 99 -83 47 -43 247 -151 355 -192 25
-9 60 -23 78 -31 18 -8 40 -14 49 -14 9 0 39 -6 67 -14 170 -48 37 -46 3051
-46 3014 0 2881 -2 3051 46 28 8 58 14 67 14 9 0 31 6 49 14 18 8 53 22 78 31
108 41 308 149 355 192 11 10 56 47 99 83 85 70 85 70 173 175 32 38 66 79 76
90 44 48 151 247 192 355 9 25 23 60 31 78 8 18 14 40 14 49 0 9 6 39 14 67
48 170 46 37 46 3051 0 3014 2 2881 -46 3051 -8 28 -14 58 -14 67 0 9 -6 31
-14 49 -8 18 -22 53 -31 78 -41 108 -149 308 -192 355 -10 11 -47 56 -83 99
-70 85 -70 85 -175 173 -38 32 -79 66 -90 76 -48 44 -247 151 -355 192 -25 9
-60 23 -78 31 -18 8 -40 14 -49 14 -9 0 -39 6 -67 14 -171 48 -35 46 -3062 45
-1721 -1 -2845 -5 -2869 -10z m1212 -3274 c19 -8 43 -15 51 -15 13 0 103 -42
187 -88 30 -16 115 -98 147 -142 36 -49 86 -144 104 -197 14 -41 14 -47 0 -61
-8 -9 -37 -19 -63 -23 -26 -4 -68 -13 -92 -21 -42 -13 -43 -12 -67 17 -13 17
-24 36 -24 44 0 27 -70 139 -114 182 -44 44 -69 59 -156 95 -36 15 -69 19
-175 19 -134 -1 -163 -7 -272 -57 -101 -46 -209 -177 -253 -308 -41 -120 -64
-415 -40 -509 7 -25 16 -68 20 -96 16 -100 64 -204 130 -280 60 -69 124 -111
235 -151 71 -26 286 -26 339 -1 19 10 53 25 73 35 49 22 173 147 196 197 10
22 25 53 33 68 8 16 14 37 14 47 0 9 7 34 15 54 17 41 35 45 92 21 19 -8 46
-15 60 -15 13 0 39 -7 58 -14 27 -12 35 -21 35 -40 0 -14 -4 -28 -10 -31 -5
-3 -10 -16 -10 -27 0 -28 -64 -159 -112 -230 -47 -68 -144 -159 -202 -188 -23
-12 -48 -25 -56 -29 -59 -32 -80 -41 -97 -41 -10 0 -36 -7 -58 -15 -48 -17
-318 -20 -380 -4 -22 6 -59 14 -82 19 -23 5 -50 13 -60 18 -10 5 -36 18 -58
28 -67 31 -181 122 -223 177 -51 67 -112 171 -112 189 0 8 -7 23 -15 34 -8 10
-15 26 -15 35 0 9 -7 30 -15 45 -8 16 -15 42 -15 57 0 16 -5 38 -11 50 -30 55
-30 500 0 530 6 6 11 23 11 39 0 28 12 59 63 168 66 139 194 271 323 334 43
21 87 43 97 48 10 5 37 13 60 18 23 5 58 13 77 18 60 17 325 14 367 -3z m1868
-30 c22 -8 49 -15 60 -15 11 0 48 -14 83 -31 96 -48 188 -165 215 -274 16 -65
20 -216 7 -260 -33 -109 -80 -185 -150 -238 -25 -18 -52 -36 -60 -40 -8 -4
-22 -11 -30 -16 -26 -16 -88 -41 -101 -41 -21 0 -99 -32 -99 -40 0 -5 20 -20
43 -33 83 -49 212 -211 343 -430 16 -27 36 -59 44 -72 8 -12 42 -66 74 -119
32 -53 63 -99 67 -102 5 -3 9 -14 9 -25 0 -18 -8 -19 -145 -19 -141 0 -146 1
-156 23 -5 12 -32 56 -59 97 -28 41 -55 84 -60 95 -6 11 -18 32 -28 46 -16 25
-88 140 -115 184 -32 52 -160 215 -199 252 -83 81 -98 85 -318 90 -163 4 -198
3 -208 -9 -9 -11 -12 -116 -14 -394 l-3 -379 -115 0 -115 0 -3 870 c-1 479 0
876 3 883 7 19 975 17 1030 -3z m1103 -15 c2 -13 10 -33 18 -44 8 -11 14 -32
14 -46 0 -14 7 -34 15 -44 8 -11 15 -31 15 -45 0 -14 7 -35 15 -45 8 -11 15
-31 15 -45 0 -14 7 -35 15 -45 8 -11 15 -31 15 -45 0 -14 7 -35 15 -45 8 -11
15 -31 15 -45 0 -14 7 -35 15 -45 8 -11 15 -31 15 -45 0 -14 7 -35 15 -45 8
-11 15 -31 15 -45 0 -14 7 -35 15 -45 8 -11 15 -31 15 -45 0 -14 7 -35 15 -45
8 -11 15 -30 15 -42 0 -12 7 -35 15 -50 8 -16 15 -36 15 -45 0 -9 7 -30 15
-45 8 -16 15 -36 15 -45 0 -9 7 -30 15 -45 8 -16 15 -36 15 -45 0 -9 7 -30 15
-45 8 -16 15 -36 15 -45 0 -9 7 -30 15 -45 8 -16 15 -39 15 -51 0 -12 4 -24 9
-28 5 -3 12 -20 16 -38 10 -49 38 -108 49 -104 6 2 14 21 19 43 4 21 12 43 17
48 6 6 10 19 10 31 0 11 7 33 15 49 8 15 15 36 15 45 0 9 7 29 15 45 8 15 15
36 15 45 0 9 7 29 15 45 8 15 15 36 15 45 0 10 7 26 15 37 8 10 15 31 15 45 0
14 7 34 15 45 8 10 15 31 15 45 0 14 7 34 15 45 8 10 15 28 15 39 0 11 7 33
15 49 8 15 15 36 15 45 0 9 7 29 15 45 8 15 15 36 15 45 0 9 7 29 15 45 8 15
15 34 15 41 0 8 6 26 14 42 15 30 33 80 46 128 13 48 31 98 46 128 8 16 14 36
14 45 0 9 7 30 15 46 8 15 15 35 15 43 0 8 6 29 14 46 8 18 16 40 20 50 5 16
20 17 163 15 l158 -3 0 -880 0 -880 -115 0 -115 0 -5 688 c-3 447 -8 687 -15
688 -5 0 -14 -18 -20 -40 -5 -22 -13 -43 -17 -47 -5 -4 -8 -16 -8 -27 0 -10
-6 -33 -14 -50 -8 -18 -16 -41 -19 -52 -3 -11 -15 -45 -27 -75 -12 -30 -25
-68 -30 -85 -13 -48 -31 -98 -46 -128 -8 -16 -14 -36 -14 -45 0 -9 -7 -30 -15
-46 -8 -15 -15 -38 -15 -50 0 -11 -7 -30 -15 -40 -8 -11 -15 -29 -15 -41 0
-12 -7 -30 -15 -41 -8 -10 -15 -31 -15 -45 0 -14 -7 -34 -15 -45 -8 -10 -15
-28 -15 -39 0 -11 -7 -33 -15 -49 -8 -15 -15 -36 -15 -45 0 -9 -7 -29 -15 -45
-8 -15 -15 -34 -15 -41 0 -8 -6 -26 -14 -42 -15 -30 -33 -80 -46 -128 -10 -37
-30 -95 -40 -115 -6 -12 -29 -15 -114 -15 l-107 0 -18 45 c-24 61 -41 109 -51
145 -13 48 -31 98 -46 128 -8 16 -14 34 -14 42 0 7 -7 26 -15 41 -8 16 -15 36
-15 45 0 9 -7 30 -15 45 -8 16 -15 36 -15 45 0 9 -7 30 -15 45 -8 16 -15 36
-15 45 0 9 -7 30 -15 45 -8 16 -15 36 -15 45 0 9 -7 30 -15 45 -8 16 -15 36
-15 45 0 9 -7 30 -15 45 -8 16 -15 38 -15 49 0 11 -7 29 -15 39 -8 11 -15 31
-15 45 0 14 -7 35 -15 45 -8 11 -15 31 -15 45 0 14 -7 35 -15 45 -8 11 -15 31
-15 45 0 14 -7 35 -15 45 -8 11 -15 30 -15 42 0 12 -7 35 -15 50 -8 16 -15 39
-15 50 0 12 -6 27 -14 33 -8 7 -18 24 -23 39 -4 16 -10 -278 -13 -698 l-5
-725 -110 0 -110 0 -3 870 c-1 479 0 876 3 883 3 10 46 12 182 10 l178 -3 3
-25z'
            />
            <path
                d='M3862 5177 c-9 -11 -12 -84 -10 -288 l3 -274 280 -3 c431 -4 536 25
610 172 16 31 20 59 20 130 -1 81 -3 95 -27 132 -28 44 -97 104 -120 104 -7 0
-25 8 -38 18 -22 15 -61 17 -365 20 -291 3 -343 2 -353 -11z'
            />
        </g>
    </SvgIcon>
)
